import { createContext, PropsWithChildren, useContext } from 'react';
import { StandaloneAppConfig } from '@/StandaloneAppConfig';

const defaultConfig: StandaloneAppConfig = {
  API_URL: '',
  NODE_ENV: 'development',
  ENABLE_PROFILING: false,
  IFRAME_URL: '',
  LAUNCH_DARKLY_CLIENT_ID: '',
  DATADOG_APPLICATION_ID: '',
  DATADOG_CLIENT_TOKEN: '',
  DATADOG_ENV: '',
};

const ConfigContext = createContext<StandaloneAppConfig>(defaultConfig);

interface ConfigProviderProps extends PropsWithChildren {
  config?: StandaloneAppConfig;
}

export const ConfigProvider: React.FC<ConfigProviderProps> = ({
  config,
  children,
}) => {
  return (
    <ConfigContext.Provider value={config ? { ...config } : defaultConfig}>
      {config ? children : null}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  return useContext(ConfigContext);
};
